var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper",class:[
    ("content-wrapper--" + _vm.type),
    { 'content-wrapper--center': _vm.center, 'content-wrapper--top-padding': _vm.topPadding }
  ]},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0c3262","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentWrapper.vue
// module id = null
// module chunks = 